export default __webpack_public_path__ + "static/media/Snd3.dd24dd13.mp3";